import GetSubsedesAsignaciones from '@/modules/equipamiento/application/GetSubsedesAsignaciones'
import GetAsignacionesBySubsede from '@/modules/equipamiento/application/GetAsignacionesBySubsede'
import CreateAsignacionEquipo from '@/modules/equipamiento/application/CreateAsignacionEquipo'
import UpdateAsignacionEquipo from '@/modules/equipamiento/application/UpdateAsignacionEquipo'
import SubsedeAsignacionApiRepository from '@/modules/equipamiento/infrastructure/SubsedeAsignacionApiRepository'

const repository = new SubsedeAsignacionApiRepository()

export default {
  namespaced: true,

  state: {
    subsedes: [],
    subsedeUsuario: null,
  },

  getters: {
    getSubsedes: (state) => state.subsedes,
    getSubsedeUsuario: (state) => state.subsedeUsuario,
  },

  mutations: {
    SET_SUBSEDES(state, subsedes) {
      state.subsedes = subsedes
    },
    SET_SUBSEDE_USUARIO(state, subsedeUsuario) {
      state.subsedeUsuario = subsedeUsuario
    },
  },

  actions: {
    async fetchSubsedesAsignaciones({ commit }) {
      try {
        const subsedes = await new GetSubsedesAsignaciones(repository).execute()
        commit('SET_SUBSEDES', subsedes)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las asignaciones de equipo por subsede.', {
          root: true,
        })
      }
    },

    async fetchAsignacionesBySubsede({ commit }, idSubSede) {
      try {
        const subsede = await new GetAsignacionesBySubsede(repository).execute(idSubSede)
        commit('SET_SUBSEDE_USUARIO', subsede)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las asignaciones de la subsede.', { root: true })
      }
    },

    async createAsignacionEquipo({ dispatch, commit }, { idSubSede, payload }) {
      try {
        const result = await new CreateAsignacionEquipo(repository).execute(idSubSede, payload)
        commit('SET_SNACKBAR_MESSAGE', 'Asignación de equipo registrada correctamente.', { root: true })
        await Promise.all([dispatch('fetchSubsedesAsignaciones'), dispatch('equipo/fetchEquipo', null, { root: true })])
        return result
      } catch (error) {
        const message = error?.response?.data?.error_message || 'No fue posible registrar la asignación de equipo.'
        commit('SET_SNACKBAR_MESSAGE', message, { root: true })
        throw error
      }
    },

    async updateAsignacionEquipo({ dispatch, commit }, { idSubSede, idDetalleAsignacion, payload }) {
      try {
        const result = await new UpdateAsignacionEquipo(repository).execute(idSubSede, idDetalleAsignacion, payload)
        commit('SET_SNACKBAR_MESSAGE', 'Asignación de equipo actualizada correctamente.', { root: true })
        await Promise.all([dispatch('fetchSubsedesAsignaciones'), dispatch('equipo/fetchEquipo', null, { root: true })])
        return result
      } catch (error) {
        const message = error?.response?.data?.error_message || 'No fue posible actualizar la asignación de equipo.'
        commit('SET_SNACKBAR_MESSAGE', message, { root: true })
        throw error
      }
    },
  },
}
